import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateTransitTimeArActions } from "store/ducks/settings/transit-time-ar";

export function* updateTransitTimeArRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/evonik-transit-times-ar/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateTransitTimeArActions.success(data));
    notify("success", "Transito atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateTransitTimeArActions.failure(errorMessage));
  }
}
